import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faHandshake, faGavel } from '@fortawesome/free-solid-svg-icons';

import PagesHeroSection from '../../components/pagesHeroSection/pagesHeroSection';
import SEOUpdater from '../../utils/hoc/SEOUpdater';
import './aboutPage.scss';

const AboutPage = () => {
  const { t } = useTranslation('aboutPage');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      {/* Dynamic SEO metadata */}
      <SEOUpdater page="aboutPage" />

      {/* Hero Section */}
      <PagesHeroSection page={t('heroTitle')} />

      {/* About Firm Content */}
      <section className="about-content-extended">
        <Container>
          <Row className="align-items-center">
            <Col md={12}>
              <h2 className="section-title">{t('aboutFirmTitle')}</h2>
              <div className="divider-left" />
              <p className="about-text">{t('aboutFirmParagraph1')}</p>
              <p className="about-text">{t('aboutFirmParagraph2')}</p>
              <p className="about-text">{t('aboutFirmParagraph3')}</p>
              <p className="about-text">{t('aboutFirmParagraph4')}</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-section">
        <div className="overlay">
          <Container>
            <h2 className="section-title text-center">{t('awardTitle')}</h2>
            <div className="section-divider mx-auto" />
            <Row className="text-center mt-5">
              <Col md={4} className="mb-4">
                <div className="icon-circle">
                  <FontAwesomeIcon icon={faTrophy} size="3x" />
                </div>
                <p className="icon-label">{t('why1')}</p>
              </Col>
              <Col md={4} className="mb-4">
                <div className="icon-circle">
                  <FontAwesomeIcon icon={faHandshake} size="3x" />
                </div>
                <p className="icon-label">{t('why2')}</p>
              </Col>
              <Col md={4} className="mb-4">
                <div className="icon-circle">
                  <FontAwesomeIcon icon={faGavel} size="3x" />
                </div>
                <p className="icon-label">{t('why3')}</p>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
